import { MSAL_CONFIG } from '@/constants';

/**
 * Build authentication URL for native OAuth flow
 */
export function buildAuthUrl(
  authority: string,
  clientId: string,
  redirectUri: string,
  state: string,
  nonce: string,
  codeChallenge: string,
): string {
  const scopes = encodeURIComponent(MSAL_CONFIG.SCOPES.FULL);
  const encodedRedirectUri = encodeURIComponent(redirectUri);
  const encodedState = encodeURIComponent(state);
  const encodedNonce = encodeURIComponent(nonce);
  const encodedCodeChallenge = encodeURIComponent(codeChallenge);

  return (
    `${authority}/oauth2/v2.0/authorize?` +
    `client_id=${clientId}&` +
    `response_type=code&` +
    `redirect_uri=${encodedRedirectUri}&` +
    `response_mode=query&` +
    `scope=${scopes}&` +
    `state=${encodedState}&` +
    `nonce=${encodedNonce}&` +
    `code_challenge=${encodedCodeChallenge}&` +
    `code_challenge_method=${MSAL_CONFIG.PKCE.CODE_CHALLENGE_METHOD}`
  );
}

/**
 * Build token request parameters for OAuth token exchange
 */
export function buildTokenRequestParams(
  clientId: string,
  code: string,
  redirectUri: string,
  codeVerifier: string,
): URLSearchParams {
  const params = new URLSearchParams();
  params.append('client_id', clientId);
  params.append('code', code);
  params.append('redirect_uri', redirectUri);
  params.append('grant_type', MSAL_CONFIG.GRANT_TYPE.AUTHORIZATION_CODE);
  params.append('code_verifier', codeVerifier);
  params.append('scope', MSAL_CONFIG.SCOPES.FULL);
  return params;
}

/**
 * Build token request for OAuth refresh (native / no redirect_uri).
 */
export function buildRefreshTokenRequestParams(
  clientId: string,
  refreshToken: string,
): URLSearchParams {
  const params = new URLSearchParams();
  params.append('client_id', clientId);
  params.append('refresh_token', refreshToken);
  params.append('grant_type', MSAL_CONFIG.GRANT_TYPE.REFRESH_TOKEN);
  params.append('scope', MSAL_CONFIG.SCOPES.FULL);
  return params;
}
